var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2160 2160",
    width: 2160,
    height: 2160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glass_new_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-761.014,1326,0,1080,1433.014)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58deff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-1579.11,383.908,0,1619.046,1870.044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d562e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e7d30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-1584.877,556.354,0,1730.366,1873.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54ff64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-1579.11,384,0,541.6,1870.044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d562e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e7d30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-1584.877,556.376,0,430.245,1873.169)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54ff64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-765,1326,0,1080,1724)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28caff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-565.332,857.223,0,1082.304,1432.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cd9ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0,-765,1326,0,1080,1136)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92eaff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: url(#g1) } \n\t\t.s1 { fill: #58deff } \n\t\t.s2 { fill: url(#g2) } \n\t\t.s3 { fill: url(#g3) } \n\t\t.s4 { fill: url(#g4) } \n\t\t.s5 { fill: url(#g5) } \n\t\t.s6 { fill: #28caff } \n\t\t.s7 { fill: url(#g6) } \n\t\t.s8 { fill: url(#g7) } \n\t\t.s9 { fill: #92eaff } \n\t\t.s10 { fill: url(#g8) } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26",
    className: "s0",
    d: "m1080 672l663 385-229 133-435.4 243-427.6-240-234-138z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy 7",
    className: "s1",
    d: "m1079 1501l-662-382m1326-61.8v63.8l-664 380-662-382 0.1-64 662 377.3zm0 63.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Brace 1 Dark",
    className: "s2",
    d: "m1478 299c-5.3-2.6-9.8-9.5-15-7.8-5.8 2-7.4 3.4-10.3 6.8-2.9 3.4-8.4 15.4-11.7 22-3.3 6.6-9.3 20.2-10.6 26-1.4 5.8-3.3 40.3-3.3 49.2-0.1 8.8 0.7 121.7 0.9 126.8 0.2 7.2 1.1 27 5 31 5 5.1 12.1 4.7 22 5 9.9 0.3 64.4 0.9 72.3 1.3 7.7 0.4 19.8 0.9 27 4.9 7.3 4 10.3 12 14 25 4 13.9 4.2 125.3 4.2 136.6 0 11.2 2.3 83.1 2.5 92.2 2.8 133 40.8 207 95.8 262.3-61.5 63.4-89.1 139.1-95.8 240.7-1 15.7-4.1 128.4-3 142 1.1 13.6-0.3 62.5 0 69 0.7 14.3-2.5 50.3-9 59-8.1 10.7-29.4 11.5-47 12-10.7 0.3-51.8 0.7-58.9 0.7-8.6 0.1-20.9 1-23.3 3.4-3.6 3.6-4.6 11.6-5 18.1-0.6 10.1-1.7 47.2-1.6 63.6 0.1 16.4 0.5 99.3 0.8 108.2 0.3 8 2.7 21.2 4.4 25.6 1.9 5 8 18.7 10.7 24.7 2.9 6.4 9.2 18.7 13.8 21.2 4.6 2.4 14.4 1.8 16.6-0.4 6.3-6.4 8.4-16.6 19.5-17.1 6.7-0.3 280.1-167.2 294.2-208.9 14.1-41.8 23.8-508.2 23.8-523.1 0-18.9-47.4-642.3-59.7-672.6-12.2-30.3-230.5-121.8-234.3-124.4-7.6-5.2-33.7-20.4-39-23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Brace 1 Light",
    className: "s3",
    d: "m1456.2 516.4c4.5 4.7 36.3 6.7 64.1 6.7 33.5 0.1 62.9-1.2 71.2 6.5 21.2 19.3 11.5 145.8 13.5 193.1 2.1 46.5-12.8 247.7 108 358.3-113.8 101.6-104 291.9-106 315-4.3 50.4 4 210-9 229-11.2 16.4-35 12.5-66.4 12.5-34.9 0-62.4-1.8-72.6 6.5-8.8 7.1-6.3 80.8-6.5 100.2-0.2 18.9-2 114.4 6 124.1 6.8 8.1 135.1 4.1 158 2.1 67.2-6 113.9-34.8 146.7-62.3 82.2-69.1 85.2-225.6 85.5-254.1 0.3-28.5 0.2-232 9.9-268.6 11.3-42.9 23.9-75 71.4-83.4 16.1-2.9 60.8 3 71.8-7.9 8.3-8.1 6.6-45.8 6.6-120.4 0-78.2 0.6-104.2-9.3-108.5-9.7-4.3-50.5-6.5-71.1-8.2-68.6-5.6-69.6-87.4-74-107.3-6.1-27.1-3.7-197.1-4.8-255.1-1.6-90.2-30.3-190.4-82.6-237.6-12.8-11.7-64.9-56.7-132.6-62.9-59.1-6.5-169-8.2-175.2-1.7-7.7 8.3-6.4 93.5-6.4 108.7 0 15.2-0.3 111.1 3.8 115.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Brace 2 Dark",
    className: "s4",
    d: "m682.6 299c5.3-2.6 9.8-9.5 15.1-7.8 5.7 2 7.3 3.4 10.2 6.8 3 3.4 8.5 15.4 11.7 22 3.3 6.6 9.3 20.2 10.7 26 1.3 5.8 3.2 40.3 3.3 49.2 0 8.8-0.8 121.7-1 126.8-0.2 7.2-1.1 27-5 31-4.9 5.1-12.1 4.7-22 5-9.9 0.3-64.4 0.9-72.3 1.3-7.6 0.4-19.8 0.9-27 4.9-7.2 4-10.3 12-14 25-4 13.9-4.2 125.3-4.2 136.6 0 11.2-2.3 83.1-2.5 92.2-2.8 133-40.8 207-95.8 262.3 61.6 63.4 89.1 139.1 95.8 240.7 1.1 15.7 4.1 128.4 3 142-1.1 13.6 0.3 62.5 0 69-0.6 14.3 2.5 50.3 9 59 8.1 10.7 29.5 11.5 47 12 10.8 0.3 51.8 0.7 58.9 0.7 8.6 0.1 21 1 23.4 3.4 3.6 3.6 4.5 11.6 4.9 18.1 0.6 10.1 1.7 47.2 1.6 63.6-0.1 16.4-0.4 99.3-0.8 108.2-0.3 8-2.7 21.2-4.3 25.6-2 5-8 18.7-10.8 24.7-2.9 6.4-9.1 18.7-13.7 21.2-4.6 2.4-14.4 1.8-16.6-0.4-6.4-6.4-8.5-16.6-19.6-17.1-6.7-0.3-280.1-167.2-294.2-208.9-14.1-41.8-23.8-508.2-23.8-523.1 0.1-18.9 47.5-642.3 59.7-672.6 12.2-30.3 230.5-121.8 234.3-124.4 7.7-5.2 33.7-20.4 39-23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Brace 2 Light",
    className: "s5",
    d: "m704.5 516.4c-4.6 4.7-36.4 6.7-64.2 6.7-33.5 0.1-62.8-1.2-71.2 6.5-21.2 19.3-11.4 145.8-13.5 193.1-2 46.5 12.9 247.7-107.9 358.3 113.7 101.6 104 291.9 105.9 315 4.3 50.4-3.9 210 9 229 11.2 16.4 35 12.5 66.4 12.5 34.9 0 62.5-1.8 72.6 6.5 8.8 7.1 6.4 80.8 6.5 100.2 0.2 18.9 2.1 114.4-6 124.1-6.7 8.1-135.1 4.1-158 2.1-67.2-6-113.8-34.8-146.6-62.3-82.3-69.1-85.3-225.6-85.6-254.1-0.3-28.5-0.2-232-9.8-268.6-11.4-42.9-23.9-75-71.5-83.4-16.1-2.9-60.8 3-71.8-7.9-8.3-8.1-6.6-45.8-6.6-120.4 0-78.2-0.5-104.2 9.3-108.5 9.7-4.3 50.5-6.5 71.1-8.2 68.6-5.6 69.6-87.4 74.1-107.3 6-27.1 3.7-197.1 4.7-255.1 1.6-90.2 30.3-190.4 82.6-237.6 12.9-11.7 64.9-56.7 132.6-62.9 59.2-6.5 169.1-8.2 175.2-1.7 7.8 8.3 6.4 93.5 6.4 108.7 0 15.2 0.3 111.1-3.7 115.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy 4",
    className: "s6",
    d: "m1079 1788l-662-382m1326-61.8v63.8l-664 380-662-382 0.1-64zm0 63.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy 2",
    className: "s7",
    d: "m1080 959l663 385-664 380-662-382z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy 3",
    className: "s8",
    d: "m1080 867.3l430.9 321.3-432.5 244-424.7-242.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy 6",
    className: "s1",
    d: "m1079 1501m462.3-330.2l34 46.1-496.3 284.1-494.4-285.9-30.2-81.9 524.7 299.1zm201.7-49.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy 5",
    className: "s9",
    d: "m1079 1200l-662-382m1326-61.8v63.8l-664 380-662-382 0.1-64zm0 63.8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Color Fill 26 copy",
    className: "s10",
    d: "m1080 371l663 385-664 380-662-382zm663 385z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassLogo);
export default __webpack_public_path__ + "static/media/glass_logo.570377a018037f9d265a27631783a9dc.svg";
export { ForwardRef as ReactComponent };